import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w100"
}
const _hoisted_2 = ["onMouseover"]
const _hoisted_3 = { class: "w100 pad10 fs16 arial fw600 posRe" }
const _hoisted_4 = {
  key: 0,
  style: {"right":"1px","top":"10px"},
  class: "fr alertRed fw600 fs11 posAb"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  class: "posAb fr",
  style: {"right":"1px","bottom":"8px"}
}
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = { class: "fs24 fw600 arial" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  class: "fs11",
  style: {}
}, "人", -1)
const _hoisted_11 = {
  key: 0,
  width: "200"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("rect", {
  x: "0",
  y: "0",
  rx: "8",
  ry: "8",
  width: "300",
  height: "30"
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("rect", {
  x: "320",
  y: "0",
  rx: "8",
  ry: "8",
  width: "80",
  height: "26"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("rect", {
  x: "0",
  y: "42",
  rx: "6",
  ry: "6",
  width: "120",
  height: "24"
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("rect", {
  x: "150",
  y: "44",
  rx: "6",
  ry: "6",
  width: "240",
  height: "20"
}, null, -1)
const _hoisted_17 = {
  key: 1,
  class: "fs28"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 0,
  class: "w100 roomTableContent",
  style: {"table-layout":"fixed"}
}
const _hoisted_21 = ["onMouseover"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContentLoader = _resolveComponent("ContentLoader")!
  const _component_SuggestedDateCell = _resolveComponent("SuggestedDateCell")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: "w100 ofs",
    style: _normalizeStyle({
            maxHeight: _ctx.from == `schedule_view` ? `500px` : ``,
            height: _ctx.from == `schedule_view` ? `` : `calc(100vh - 220px - 143px - 58px)`,
        })
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(`timespanTitle fl ${_ctx.columnWidthClass || `w20`}`),
      style: _normalizeStyle({
                maxWidth: _ctx.isSP ? `350px` : ``,
            })
    }, [
      (_ctx.Util.isPresent(_ctx.vrm.suggestedMembers))
        ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayDates(), (pd, pdindex) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: `${pdindex}${pd.start_time} ${_ctx.okDates?.length}${_ctx.vrm.didConflictCheck}`,
                height: "58",
                onMouseover: ($event: any) => (_ctx.mouseoverTr(pd, pdindex))
              }, [
                _createElementVNode("td", {
                  width: "200",
                  class: _normalizeClass(`${
                            _ctx.vrm.maxAttendeesNum == _ctx.vrm.numberList[pd.start_time]
                                ? `orangeBg`
                                : _ctx.vrm.maxAttendeesNum - 1 == _ctx.vrm.numberList[pd.start_time]
                                ? `lorangeBg`
                                : ``
                        }`),
                  style: {
                            borderRadius: `10px 0 0 10px`,
                        }
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("span", null, _toDisplayString(pd.jp_format), 1),
                    (pd.start_time < _ctx.now)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t(`schedule.overstart_short`)), 1))
                      : _createCommentVNode("", true),
                    (_ctx.mouseoverIndex == pdindex && !_ctx.onlyShowDates)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "circle_button skyblueBg rad4 fs11",
                          style: {"padding":"4px 8px"},
                          onClick: ($event: any) => (_ctx.confirmDate(pd))
                        }, _toDisplayString(_ctx.$t(`schedule.confirm`)), 9, _hoisted_5))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_6, [
                      (pd.did_check_conflict ? pd.is_conflict : false)
                        ? _withDirectives((_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.$getAssetImageUrl(`/assets/icons/bikkuri_yellow.png`),
                            width: "24"
                          }, null, 8, _hoisted_7)), [
                            [_directive_tooltip, `調整ページ作成後に、あなたが作成した調整カレンダーのカレンダーに予定が入りました`]
                          ])
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_8
                  ])
                ], 2),
                _createElementVNode("td", {
                  width: "60",
                  class: _normalizeClass(`centered ${
                            _ctx.vrm.maxAttendeesNum == _ctx.vrm.numberList[pd.start_time]
                                ? `orangeBg`
                                : _ctx.vrm.maxAttendeesNum - 1 == _ctx.vrm.numberList[pd.start_time]
                                ? `lorangeBg`
                                : ``
                        }`),
                  style: {
                            borderRadius: `0px 10px 10px 0px`,
                        }
                }, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.vrm.numberList[pd.start_time]), 1),
                  _hoisted_10
                ], 2),
                (_ctx.showMyVoteView)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_11, [
                      (!_ctx.okDates)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createVNode(_component_ContentLoader, null, {
                              default: _withCtx(() => [
                                _hoisted_13,
                                _hoisted_14,
                                _hoisted_15,
                                _hoisted_16
                              ]),
                              _: 1
                            })
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createElementVNode("span", {
                              class: _normalizeClass(`dli_circle mr10 ${_ctx.okDates.includes(pd.start_time) ? `selected` : ``}`),
                              onClick: ($event: any) => (_ctx.selectOK(pd, pdindex))
                            }, null, 10, _hoisted_18),
                            _createElementVNode("span", {
                              class: _normalizeClass(`dli_close ml10 ${!_ctx.okDates.includes(pd.start_time) ? `selected` : ``}`),
                              onClick: ($event: any) => (_ctx.selectNO(pd, pdindex))
                            }, null, 10, _hoisted_19)
                          ]))
                    ]))
                  : _createCommentVNode("", true)
              ], 40, _hoisted_2))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ], 6),
    _createElementVNode("div", {
      id: "MembersVotedInfo",
      class: _normalizeClass(`availableTimeTable MembersVotedInfo fl ${_ctx.cellWidthClass || `w80`} ofs`)
    }, [
      (_ctx.Util.isPresent(_ctx.vrm.suggestedMembers))
        ? (_openBlock(), _createElementBlock("table", _hoisted_20, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayDates(), (pd, pdindex) => {
              return (_openBlock(), _createElementBlock("tr", {
                onMouseover: ($event: any) => (_ctx.mouseoverTr(pd, pdindex)),
                key: `${pdindex}${pd.start_time}`,
                height: "58"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vrm.suggestedMembers, (mem, memindex) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: `${memindex}${mem.id}`,
                    class: _normalizeClass(`${memindex % 2 == 1 ? `yellowBg` : ``}`),
                    style: _normalizeStyle({
                            width: _ctx.from == `schedule_view` ? `120px` : `220px`,
                            height: `58px`,
                        })
                  }, [
                    _createVNode(_component_SuggestedDateCell, {
                      mem: mem,
                      pd: pd
                    }, null, 8, ["mem", "pd"])
                  ], 6))
                }), 128))
              ], 40, _hoisted_21))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ], 4))
}